import Detail1 from 'images/games/solitaire-clash/detail1.png'
import Detail2 from 'images/games/solitaire-clash/detail2.png'
import Detail3 from 'images/games/solitaire-clash/detail3.png'
import Footer from 'images/games/solitaire-clash/footer.png'
import Icon from 'images/games/solitaire-clash/icon.webp'
import Swiper1 from 'images/games/solitaire-clash/swiper1.webp'
import Swiper2 from 'images/games/solitaire-clash/swiper2.webp'
import Swiper3 from 'images/games/solitaire-clash/swiper3.webp'
import Swiper4 from 'images/games/solitaire-clash/swiper4.webp'
import Swiper5 from 'images/games/solitaire-clash/swiper5.webp'
import Swiper6 from 'images/games/solitaire-clash/swiper6.webp'
import Swiper7 from 'images/games/solitaire-clash/swiper7.webp'
import { GamesLink, SolitaireInfiniteLink, SolitaireSlamLink, SolitaireVentureLink } from '../../components'
import { SolitaireClashEntity } from './entity'
import { TemplatePageProps } from './types'

export const SolitaireClashDetail: TemplatePageProps = {
  entity: {
    ...SolitaireClashEntity,
    logo: Icon,
    title: (
      <>
        <strong>Solitaire Clash: Champion of Free Solitaire Games</strong>
      </>
    ),
    description: (
      <>
        Enjoy <strong>Klondike Solitaire</strong> with a twist in <strong>Solitaire Clash!</strong> Solitaire Clash is a
        welcoming and competitive game full of thrilling fun! Compete in multiplayer tournaments, join weekly events,
        and win real cash prizes! Download from the Apple Store, Galaxy Store, and the Android APK directly on your
        phone. Start your Solitaire journey today!
      </>
    ),
  },
  media: {
    facebook: 'https://www.facebook.com/SolitaireClashAvia',
    instagram: 'https://www.instagram.com/solitaireclash/',
  },
  swiper: [
    { image: Swiper1 },
    { image: Swiper2 },
    { image: Swiper3 },
    { image: Swiper4 },
    { image: Swiper5 },
    { image: Swiper6 },
    { image: Swiper7 },
  ],
  content: [
    {
      title: 'How to Play Free Solitaire?',
      description: (
        <>
          Learning how to play <strong>Solitaire Clash</strong> is clear and easy. Start by arranging a standard 52-card
          deck into seven tableau columns. Move cards by suit in ascending order, beginning with Aces, into foundation
          piles. Tap to transfer cards from the stockpile and clear the board as efficiently as possible. Speed and
          accuracy boost your score, with higher rewards for quick clears. No ads will interrupt your game, keeping you
          fully focused on strategy and winning. With short, exciting rounds, it’s free Solitaire reimagined for
          competitive fun—perfect for fitting into your busy life!
        </>
      ),
      image: Detail1,
    },
    {
      title: 'Thrive in Fair Multiplayer Tournaments',
      description:
        "Solitaire Clash offers a fair, skill-based, real-money experience through exciting multiplayer tournaments! Players of all levels enjoy the same card layouts and time limits, making every match a true test of skill. Whether you’re a beginner or a pro, it’s easy to jump in, sharpen your strategy, and climb the leaderboard. There’s no steep learning curve, and quick matches fit perfectly into busy schedules. Start with free Gem tournaments, then level up to compete in real-cash games or join thrilling weekly events. Whether you're here to relax or rise to the top—every game counts!",
      image: Detail2,
    },
    {
      title: 'Secure Gaming, Trusted Rewards',
      description: (
        <>
          Your safety is our priority. We use advanced encryption to protect your information and gameplay, ensuring
          every match is secure. Trusted payment partners ensure fast PayPal cashouts and easy deposits via{' '}
          <strong>PayPal</strong>,<strong>Venmo</strong>, <strong>Apple Pay</strong>, <strong>Visa</strong>,{' '}
          <strong>Mastercard</strong>, <strong>Amex</strong>, and <strong>Discover</strong>—making it easy to join cash
          tournaments.
        </>
      ),
      image: Detail3,
    },
    {
      title: 'Play, Compete, Win Now!',
      description: (
        <>
          Solitaire Clash transforms classic Klondike Solitaire into a thrilling, skill-based game with real cash
          prizes. Identical card layouts, time limits, and all functions ensure fairness for all. Practice with free
          games, then join real-money tournaments to compete and win. Enjoy seasonal events like Sweet Blast, Passport
          Puzzler, and more—for fresh challenges and rewards. Competitive or casual, there’s always something new to be
          excited about! Love Solitaire? Check out other Avia favorites like <SolitaireSlamLink strong />
          , <SolitaireVentureLink strong />, and <SolitaireInfiniteLink strong /> for more exciting{' '}
          <GamesLink strong>card games</GamesLink>!
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
}
